import React from "react"
import {
  ParallaxPhotosWrapper,
  PhotosContainer,
  Photo__0,
  Photo__1,
  Photo__2,
} from "./styles"
import Image from "gatsby-image"
import { Parallax } from "react-scroll-parallax"

const ParallaxPhotos = ({ imagesHook, bigtitle }) => {
  const imgs = imagesHook
  return (
    <ParallaxPhotosWrapper>
      <PhotosContainer>
        {imgs.second && (
          <Photo__0>
            <Parallax y={["0px", "-100px"]}>{imgs.second}</Parallax>
          </Photo__0>
        )}
        {imgs.first && (
          <Photo__1>
            <Parallax y={["0px", "-250px"]}>{imgs.first}</Parallax>
          </Photo__1>
        )}
        {imgs.third && (
          <Photo__2>
            <Parallax y={["0px", "-350px"]}>{imgs.third}</Parallax>
          </Photo__2>
        )}
      </PhotosContainer>
    </ParallaxPhotosWrapper>
  )
}

export { ParallaxPhotos }
